const validateCustomerData = (customer) => {
  const errors = {};

  // Validasi Full Name
  if (!customer.fullName || typeof customer.fullName !== "string" || customer.fullName.length < 3 || customer.fullName.length > 100) {
      errors.fullName = "Nama lengkap harus berupa string dengan panjang antara 3 hingga 100 karakter.";
  }

  // Validasi Email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!customer.email || !emailRegex.test(customer.email)) {
      errors.email = "Format email tidak valid.";
  }

  // Validasi Phone (nomor Indonesia)
  const phoneRegex = /^(\+62|62|0)8[1-9][0-9]{7,11}$/;
  if (!customer.phone || !phoneRegex.test(customer.phone)) {
      errors.phone = "Nomor telepon tidak valid. Harus dimulai dengan 08 atau kode negara +62.";
  }

  return errors;
};

export default validateCustomerData;
